import { IconProps } from '@tabler/icons-react'
import {
  createElement,
  ReactElement,
  ReactNode,
} from 'react'

import { FeatureKey } from '@/constants/feature-key'

export interface FeatureConfig {
  page?: () => ReactNode;
  icon?: (props: IconProps) => ReactNode;
  hideInMenu?: boolean;
}

export type MenuConfig = Partial<{
  [key in FeatureKey]: FeatureConfig;
}>

export interface MenuItem {
  key: string,
  label: string,
  icon: ReactElement<IconProps>,
  popupOffset: [number, number],
  style: Record<string, number | string | boolean>
}

export const createMenuItem = (key: string, name: string) => {
  const config = window.menuConfig[key as FeatureKey]
  return {
    key: key,
    label: name,
    icon: config?.icon && createElement(config.icon, { size: 18 }),
    popupOffset: [12, 0],
    style: config?.hideInMenu ? { display: 'none' } : undefined,
  } as MenuItem
}

